module.exports = __webpack_public_path__ + "img/aspect-ratio-16-9.b4a14985.svg";